"use strict";

window.site = window.site || {};

/**
 * Init Book A Room related scripts
 * @class Site
 * @static
 */
site.BookARoom = function BookARoom() {
  'use strict';

  /**
   * jQuery elements
   * @private
   */
  var $hallRoomButtons;
  var $halls;
  var $heroCta;

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

  /**
   * Initialize hall CTA buttons to pre-populate form
   * @private
   */
  var initHallCta = function initHallCta() {
    var hallCtas = document.querySelectorAll('.hall-item-cta');
    if (hallCtas.length === 0) {
      console.log('BookARoom: No hall CTA buttons found');
      return;
    }
    console.log("BookARoom: Found ".concat(hallCtas.length, " hall CTA buttons"));
    hallCtas.forEach(function (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        var roomId = cta.dataset.roomId;
        if (!roomId) {
          console.warn('BookARoom: No room ID found on CTA');
          return;
        }
        console.log('BookARoom: CTA clicked for room ID:', roomId);

        // Find the form
        var form = document.querySelector('.hero-form');
        if (!form) {
          console.warn('BookARoom: Hero form not found');
          return;
        }

        // Scroll to the form
        form.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        // Pre-select the room in the dropdown after scroll
        setTimeout(function () {
          var roomSelect = form.querySelector('select[name="room"]');
          if (roomSelect) {
            roomSelect.value = roomId;
            console.log('BookARoom: Pre-selected room:', roomId);

            // Add visual feedback - highlight the select
            roomSelect.style.transition = 'all 0.3s ease';
            roomSelect.style.boxShadow = '0 0 0 3px rgba(255, 184, 0, 0.3)';
            setTimeout(function () {
              roomSelect.style.boxShadow = '';
            }, 2000);
          } else {
            console.warn('BookARoom: Room select not found in form');
          }
        }, 800);
      });
    });
  };

  /**
   * Initialize hero CTA smooth scroll
   * @private
   */
  var initHeroCta = function initHeroCta() {
    var heroCta = document.querySelector('.hero-cta');
    if (!heroCta) {
      console.log('BookARoom: Hero CTA button not found');
      return;
    }
    console.log('BookARoom: Found hero CTA button, attaching scroll listener');
    heroCta.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var hallList = document.querySelector('#hall-list');
      if (!hallList) {
        console.warn('BookARoom: Hall list section not found');
        return;
      }
      console.log('BookARoom: Scrolling to hall list');

      // Smooth scroll to hall-list section using native API
      hallList.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  };

  /**
   * Initialize room selection buttons
   * @private
   */
  var initRoomSelection = function initRoomSelection() {
    var hallRoomButtons = document.querySelectorAll('.hall-room-button');
    console.log("BookARoom: Found ".concat(hallRoomButtons.length, " room buttons"));
    if (hallRoomButtons.length === 0) {
      return;
    }
    hallRoomButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        var roomIndex = button.dataset.roomIndex;
        var hallIndex = button.dataset.hall;
        console.log('BookARoom: Button clicked - Room:', roomIndex, 'Hall:', hallIndex);
        var hall = document.querySelector(".hall[data-hall-index=\"".concat(hallIndex, "\"]"));
        if (!hall) {
          console.error('BookARoom: Hall not found for index', hallIndex);
          return;
        }
        console.log('BookARoom: Found hall');

        // Update button states
        hall.querySelectorAll('.hall-room-button').forEach(function (btn) {
          return btn.classList.remove('is-active');
        });
        button.classList.add('is-active');

        // Hide all room headers in this hall
        hall.querySelectorAll('.hall-item-header').forEach(function (header) {
          return header.classList.remove('is-active');
        });

        // Show selected room header (title + price)
        var selectedHeader = hall.querySelector(".hall-item-header[data-room=\"".concat(roomIndex, "\"][data-hall=\"").concat(hallIndex, "\"]"));
        if (selectedHeader) {
          console.log('BookARoom: Found header');
          selectedHeader.classList.add('is-active');
        }

        // Hide all room content in this hall
        hall.querySelectorAll('.hall-item-content').forEach(function (content) {
          return content.classList.remove('is-active');
        });

        // Show selected room content (text + CTA)
        var selectedContent = hall.querySelector(".hall-item-content[data-room=\"".concat(roomIndex, "\"][data-hall=\"").concat(hallIndex, "\"]"));
        if (selectedContent) {
          console.log('BookARoom: Found content');
          selectedContent.classList.add('is-active');
        }

        // Hide all sliders in this hall
        hall.querySelectorAll('.hall-item-slider').forEach(function (slider) {
          return slider.classList.remove('is-active');
        });

        // Show selected slider
        var selectedSlider = hall.querySelector(".hall-item-slider[data-room=\"".concat(roomIndex, "\"][data-hall=\"").concat(hallIndex, "\"]"));
        if (selectedSlider) {
          console.log('BookARoom: Found slider');
          selectedSlider.classList.add('is-active');

          // Reinitialize Flickity if needed
          var flickityElement = selectedSlider.querySelector('.flickity-slider');
          if (flickityElement && typeof Flickity !== 'undefined') {
            var flktyInstance = Flickity.data(flickityElement);
            if (flktyInstance) {
              console.log('BookARoom: Resizing Flickity');
              setTimeout(function () {
                flktyInstance.resize();
                flktyInstance.reposition();
              }, 50);
            }
          }
        }
      });
    });
  };

  /**
   * Adjust hero height based on form height
   * @private
   */
  var adjustHeroHeight = function adjustHeroHeight() {
    var hero = document.querySelector('.book-a-room-hero');
    var form = document.querySelector('.hero-form-wrapper');
    if (!hero || !form) {
      console.log('BookARoom: Hero or form not found for height adjustment');
      return;
    }

    // Only apply on desktop (above 895px)
    if (window.innerWidth > 895) {
      var formHeight = form.offsetHeight;
      var heroBottom = document.querySelector('.hero-bottom');
      var heroBottomHeight = heroBottom ? heroBottom.offsetHeight : 0;

      // Calculate minimum height needed: form height + hero-bottom height
      var minHeight = formHeight + heroBottomHeight;

      // Apply the height
      hero.style.minHeight = minHeight + 'px';
      console.log('BookARoom: Hero height adjusted to', minHeight + 'px');
    } else {
      // Remove fixed height on mobile
      hero.style.minHeight = '';
      console.log('BookARoom: Hero height reset for mobile');
    }
  };

  /**
   * Initialize date and time input masks (REMOVED - using tail.DateTime instead)
   * @private
   */
  var initDateTimeMasks = function initDateTimeMasks() {
    // Date/time inputs now handled by tail.DateTime in _hero-switch.js
    // This function is kept for backward compatibility but does nothing
    console.log('BookARoom: Date/time inputs handled by tail.DateTime');
  };

  /**
   * Initialize form validation (REMOVED - handled by HTML5 and tail.DateTime)
   * @private
   */
  var initFormValidation = function initFormValidation() {
    // Form validation now handled by:
    // - HTML5 required attributes
    // - tail.DateTime for date validation
    // - Server-side validation in DefaultController
    console.log('BookARoom: Form validation handled by HTML5 and server-side');
  };

  /**
   * Initialize Flickity sliders
   * @private
   */
  var initFlickitySliders = function initFlickitySliders() {
    var sliders = document.querySelectorAll('.flickity-slider');
    console.log("BookARoom: Found ".concat(sliders.length, " sliders"));
    if (sliders.length === 0) {
      console.warn('BookARoom: No sliders found');
      return;
    }
    if (typeof Flickity === 'undefined') {
      console.error('BookARoom: Flickity is not defined');
      return;
    }
    sliders.forEach(function (slider) {
      // Skip if already initialized
      if (slider.classList.contains('flickity-enabled')) {
        console.log('BookARoom: Slider already initialized, skipping');
        return;
      }
      console.log('BookARoom: Initializing Flickity on slider');

      // Initialize Flickity using native constructor
      new Flickity(slider, {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        imagesLoaded: true
      });
    });
  };

  /**
   * Initializes the class.
   * @public
   */
  var init = function init() {
    // Abort if already initialized
    if (inited) {
      console.warn('BookARoom: Already initialized');
      return false;
    }
    console.log('BookARoom: Initializing...');
    inited = true;

    // Initialize hero CTA smooth scroll
    initHeroCta();

    // Initialize hall CTA buttons
    initHallCta();

    // Initialize room selection
    initRoomSelection();

    // Initialize Flickity sliders
    initFlickitySliders();

    // Initialize date/time input masks
    initDateTimeMasks();

    // Initialize form validation
    initFormValidation();

    // Adjust hero height based on form
    adjustHeroHeight();

    // Re-adjust on window resize
    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        adjustHeroHeight();
      }, 250);
    });
    console.log('BookARoom: Initialization complete');
    return true;
  };

  // Expose public methods & properties
  return {
    init: init
  };
}();